export class optionchainModel {
setValue(res){
if(res){

}
}
}